module.exports = __webpack_public_path__ + "static/media/PITCH_grey.c4ad7861.webp";